export default "__VITE_ASSET__D4$HzbP8__"